import { __decorate } from "tslib";
import { debounce } from 'lodash';
import { Vue, Component, Prop, ProvideReactive } from 'vue-property-decorator';
import { sortChildren } from '../util';
// 防止复杂表单高频率执行该方法
const sortChildrenWithDebounce = debounce(sortChildren, 100);
let Form = class Form extends Vue {
    constructor() {
        super(...arguments);
        // 为表单项提供form对象
        this.formInstance = null;
        // 表单项对象
        this.fields = [];
    }
    // 追加表单项
    appendField(field) {
        this.fields.push(field);
        sortChildrenWithDebounce(this.fields, this);
    }
    // 删除指定的表单项
    removeField(field) {
        this.fields = this.fields.filter(item => item !== field);
    }
    // 表单数据验证、收集表单异常信息，便于代码触发表单提交
    submitForm() {
        this.validateAll().then(() => {
            this.$emit('submit', [], this.getValues());
        }).catch(errors => {
            this.$emit('submit', errors, this.getValues());
        });
    }
    // 验证表单是否填写完
    checkReady() {
        return !this.fields.map(field => field.checkReady()).some(isReady => !isReady);
    }
    // 验证所有的表单数据
    validateAll() {
        return new Promise((resolve, reject) => {
            Promise.all(this.fields.map(field => field.validate())).then(errors => {
                errors = errors.filter(item => !!item);
                if (!errors.length) {
                    resolve();
                }
                else {
                    reject(errors);
                }
            });
        });
    }
    // 获取表单项数据
    getValues() {
        return this.fields.reduce((formData, field) => ({
            ...formData,
            [field.name]: field.getValue()
        }), {});
    }
    created() {
        this.formInstance = this;
    }
    render() {
        return (<form onSubmit={this.onSubmitForm} style={{
            backgroundColor: '#fff'
        }}>
        {this.$slots.default}
      </form>);
    }
    onSubmitForm(event) {
        event.preventDefault();
        this.submitForm();
    }
};
__decorate([
    Prop({
        type: Number,
        default: 102
    })
], Form.prototype, "labelWidth", void 0);
__decorate([
    Prop({
        type: String,
        default: 'left'
    })
], Form.prototype, "labelAlign", void 0);
__decorate([
    Prop({
        type: Number,
        default: 2
    })
], Form.prototype, "maxLabelLines", void 0);
__decorate([
    Prop({
        type: String,
        default: 'left'
    })
], Form.prototype, "inputAlign", void 0);
__decorate([
    Prop({
        type: Number,
        default: 52
    })
], Form.prototype, "inputHeight", void 0);
__decorate([
    Prop({
        type: String,
        default: 'normal'
    })
], Form.prototype, "fieldFontSize", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false
    })
], Form.prototype, "noBorder", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false
    })
], Form.prototype, "noErrMsg", void 0);
__decorate([
    ProvideReactive('form')
], Form.prototype, "formInstance", void 0);
Form = __decorate([
    Component({
        // 防止storybook中出现'Cannot redefine property "form"'的问题
        inject: []
    })
], Form);
export default Form;
//# sourceMappingURL=index.jsx.map